
import { Mixins, Component } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { IFileIntegrations } from '@/api/types/uapi';
import { getAffiliatesList, getFileIntegrations, postFileIntegrations } from '@/api/uapi';
import Filters from '@/components/base/filters/Filters.vue';
import SvgApplication from '@/assets/icons/nav-bar/application.svg';
import { showNotification, showServerError } from '@/utils';
import TableMixin from "@/mixins/table";
import { IFilter } from '@/types';
import { filterClass } from '@/services/filters/filterClass';
import { SEARCH_VALUE_DEBOUNCE, MAX_LIMIT_FOR_SELECT } from "@/configs/global";

@Component({
    components: {
        Filters,
        SvgApplication,
    },
})

export default class FileIntegrations extends Mixins(TableMixin) {
    @Mutation('SET_FILTERS_PARAMS_OBJECT') setFiltersParamObject;

    apiMethod = getFileIntegrations;
    dataTable: IFileIntegrations[] = [];
    totalElementDataTable = 0;
    filters: IFilter[] = [
        new filterClass.ComboboxArray({
            id: 'affiliate_id',
            label: 'ID партнера',
            select: [],
            supValue: '',
        }),
        new filterClass.Multiselect({
            id: 'status',
            items: ['unprocessed', 'processed'],
            type: 'string',
            label: 'Статус',
            select: [],
        }),
        new filterClass.Datepicker({
            id: 'created',
            label: 'Дата создания',
            pickerType: 'date',
            select: [],
            range: true,
        }),
    ];
    headers = [
        {
            text: 'ID партнера',
            value: 'affiliate_id',
            sortable: false,
        },
        {
            text: 'Статус',
            value: 'status',
            sortable: false,
        },
        {
            text: 'Всего заявок',
            value: 'total',
            sortable: false,
        },
        {
            text: 'Заявки с ошибками',
            value: 'failed',
            sortable: false,
        },
        {
            text: 'Дубли заявок',
            value: 'duplicate',
            sortable: false,
        },
        {
            text: 'Дата создания',
            value: 'created_at',
        },
    ];
    statuses = [
        {
            slot: 'item.status',
            key: 'status',
            translate: (status: string): { color: string; text: string } | undefined => {
                if (status === 'processed') return { color: 'green', text: 'processed' };
                if (status === 'unprocessed') return { color: 'red', text: 'unprocessed' };
            },
        },
    ];
    settings = {
        title: 'Файловые интеграции',
        loading: false,
    };
    isShowAddFileDialog: boolean = false;
    searchTimerId = 0;
    autocompleteModel: number | null = null;
    autocompleteSearch: string = '';
    autocompleteLoading: boolean = false;
    autocompleteItems: Record<string, unknown>[] = [];
    uploadModel: File | null = null;

    async uploadFile(): Promise<void> {
        try {
            if (this.uploadModel && this.autocompleteModel) {
                await postFileIntegrations({
                    affiliate_id: this.autocompleteModel,
                    file: this.uploadModel,
                });
                await this.getFileIntegrations();
                showNotification('Задание успешно создано.');
                this.isShowAddFileDialog = false;
            }
        } catch (e) {
            showServerError(e);
            this.autocompleteModel = null;
            this.uploadModel = null;
        }
    }

    debounceQuerySelections(): void {
        if (this.autocompleteSearch) {
            clearTimeout(this.searchTimerId);
            this.searchTimerId = window.setTimeout(async () => {
                try {
                    this.autocompleteLoading = true;
                    const splittingValue = this.autocompleteSearch!
                        .trim().replace(/\s/g, ' ').split(' ');
                    const params = {
                        [splittingValue.length > 1 ? 'id' : 'query']: splittingValue.length > 1
                            ? splittingValue : this.autocompleteSearch!,
                        limit: MAX_LIMIT_FOR_SELECT,
                    };
                    const { data: result }: any = await getAffiliatesList(params as any);

                    if (!this.autocompleteItems) {
                        this.autocompleteItems = [];
                    }

                    result.forEach((item) => {
                        this.autocompleteItems.push({
                            id: item.id,
                            name: `${item.id} ${item.name}`,
                        });
                    });
                } catch (e) {
                    showServerError(e, 'Список не загружен');
                } finally {
                    this.autocompleteLoading = false;
                }
            }, SEARCH_VALUE_DEBOUNCE);
        }
    }

    created(): void {
        const activeFilters = {};
        this.filters.forEach((fl) => {
            if (fl.select) {
                if (fl.datepicker) {
                    activeFilters[`${fl.id}_from`] = fl.select[0];
                    activeFilters[`${fl.id}_to`] = fl.select[0];
                }
            }

        });
        const activeParams = JSON.parse(JSON.stringify({ ...activeFilters }));
        this.setFiltersParamObject(activeParams);
    }

    mounted(): void {
        this.getFileIntegrations();
    }

    async getFileIntegrations(offset?: number): Promise<void> {
        try {
            await this.getTableData(offset);
        } catch (err) {
            showServerError(err, 'Список файловых интеграций не загружен');
        }
    }
}
